<app-header [header-data]="headerData"></app-header>
<form [formGroup]="registerForm">
  <div class="container px-5 px-md-0">
    <div class="form-template">
      <div class="row">
        <div class="col-md-12">
          <h2>{{labelCaption['Account_Details']}}</h2>
        </div>
      </div>
      <div *ngIf="lockScreen">
        <br>
      <div class="creditoruser-notification">
        This record is currently being worked on by another member. Please try again later.
      </div>
      </div> 
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">{{labelCaption['First_Name']}}</label>
            <input formControlName="userfirstName" class="form-control is-disabled" [(ngModel)]="userAccount.firstName" placeholder="First Name" readonly>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">{{labelCaption['Last_Name']}}</label>
            <input formControlName="userlastName" class="form-control is-disabled" [(ngModel)]="userAccount.lastName" placeholder="Last Name" readonly>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">{{labelCaption['Email_Address']}}</label>
            <input formControlName="useremail" class="form-control is-disabled" [(ngModel)]="userAccount.emailAddress" placeholder="Email" readonly>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-label">
                  {{labelCaption['Country_Code']}}
                </label>
                <input formControlName="usercountryCode" class="form-control is-disabled" [(ngModel)]="creditorContact.countryCode" placeholder="Country Code" readonly>
              </div>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <label class="form-label">{{labelCaption['Contact Number']}}</label>
                <input formControlName="usercontactNumber" type="number" class="form-control is-disabled" [(ngModel)]="creditorContact.contactNumber"
                       placeholder="Contact Number" readonly>
              </div>
            </div>
            <div class="col-md-12">
              <div class="add-contact-section">
                <div class="row no-gutters mb-4"  *ngFor="let item of userContactList"> 
                  <div class="col-2">
                    <div class="labelcont"> +{{item.countryCode}} </div>
                  </div>
                  <div class="col">
                    <div class="labelcont">{{item.contactNumber}} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">
              {{labelCaption['Name_Company']}}
            </label>

            <mat-form-field [floatLabel]="'never'">
              <mat-label>Select</mat-label>
              <mat-select formControlName="engagementlist" id="inputState" class="form-control" (selectionChange)="getCreditorName($event)">
                <mat-option *ngFor="let value of engagemetList" [value]="value.engagementId">
                  {{value.engagementName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">
              {{labelCaption['Creditor_Name']}}
            </label>
            <mat-form-field [floatLabel]="'never'">
              <mat-label>Select</mat-label>
              <mat-select formControlName="creditorlist" id="inputState" class="form-control" [disabled]="isFieldDisabled" (selectionChange)="getCreditorDetails($event)">
                <mat-option *ngFor="let value of creditorList" [value]="value.creditorId">
                  {{value.creditorName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div *ngIf="showCompanyForm && isCreditorSelected">
        <h2>{{labelCaption['Creditor_Information']}} </h2>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">

              <label class="form-label">{{labelCaption['Name']}}</label>
              <input formControlName="name" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.creditorName" placeholder="Name" readonly>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">{{labelCaption['Uen']}}</label>
              <input formControlName="uen" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.creditorUEN" placeholder="UEN" readonly>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">
                {{labelCaption['Company Address']}}
                <span class="info-icon"
                      matTooltip="Please inform the liquidators/judicial managers of any change in address. This shall be the correspondence address for all paper correspondences. Unless otherwise indicated, all correspondences will be made electronically through the electronic mail."
                      aria-label="Button that displays a tooltip when focused or hovered over"
                      matTooltipPosition="right"></span>
              </label>
              <input formControlName="postalAddress" class="form-control is-disabled" placeholder="Registered Address Line 1"
                     [(ngModel)]="detailsOfUsers.postalAddressLine1" readonly>
              <input type="email" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.postalAddressLine2" [ngModelOptions]="{standalone: true}" placeholder="Registered Address Line 2" readonly>
              <input type="email" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.postalAddressLine3" [ngModelOptions]="{standalone: true}" placeholder="Registered Address Line 3" readonly>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">{{labelCaption['Country']}}</label>

              <input formControlName="country" type="text" placeholder="Select Country"
                     [(ngModel)]="detailsOfUsers.postalCountry" class="form-control is-disabled" readonly>

            </div>
            <div class="form-group">
              <label class="form-label">{{labelCaption['Postal Code']}}</label>
              <input formControlName="postalCode" class="form-control is-disabled" placeholder="Postal Code"
                     [(ngModel)]="detailsOfUsers.postalCode" readonly>

            </div>
          </div>
        </div>

        <div class="row mb-5">
          <div class="col-md-12">
            <mat-checkbox [checked]="checkBoxProperty" [disabled]="true">The postal address is the same as the registered address.</mat-checkbox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">
                {{labelCaption['Correspondence Mailing Address']}}
                <span class="info-icon"
                      matTooltip="Do inform the liquidators/judicial managers of any change in address.

                  This shall be the correspondence address for all paper correspondences.  Unless otherwise indicated, all correspondence will be done  electronically through email."
                      aria-label="Button that displays a tooltip when focused or hovered over"
                      matTooltipPosition="right"></span>
              </label>
              <input formControlName="correspondanceAddress" class="form-control is-disabled" placeholder="Postal Address Line 1" [(ngModel)]="detailsOfUsers.correspondenceMailingAddressLine1" readonly>

              <input type="email" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.correspondenceMailingAddressLine2" [ngModelOptions]="{standalone: true}" placeholder="Postal Address Line 2" readonly>
              <input type="email" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.correspondenceMailingAddressLine3" [ngModelOptions]="{standalone: true}" placeholder="Postal Address Line 3" readonly>
            </div>
          </div>
          <div class="col-md-6">

            <div class="form-group">
              <label class="form-label">{{labelCaption['Country']}}</label>

              <input formControlName="country2" type="text" placeholder="Select Country" class="form-control is-disabled"
                     [(ngModel)]="detailsOfUsers.correspondenceMailingCountry" readonly>
            </div>
            <div class="form-group">
              <label class="form-label">{{labelCaption['Postal Code']}}</label>
              <input formControlName="postalCode2" class="form-control is-disabled" placeholder="Postal Code"
                     [(ngModel)]="detailsOfUsers.correspondenceMailingPostalCode" readonly />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">{{labelCaption['Email']}}</label>
              <input type="email" formControlName="email" class="form-control is-disabled"
                     [(ngModel)]="detailsOfUsers.emailAddress" placeholder="Email Address" readonly>

            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label">
                    {{labelCaption['Country_Code']}}
                  </label>
                  <input formControlName="countryCode" class="form-control is-disabled"
                         placeholder="Country Code" readonly>

                </div>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <label class="form-label">{{labelCaption['Creditor_Contact']}}</label>
                  <div class="add-contact-parent">
                    <input type="number" formControlName="contactNumber" class="form-control is-disabled"
                           placeholder="Contact Number" readonly>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-md-12 px-0">
              <div class="add-contact-section">
                <div class="row no-gutters"  *ngFor="let item of detailsOfUsers.creditorContact"> 
                  <div class="col-2">
                    <div class="labelcont"> +{{item.countryCode}} </div>
                  </div>
                  <div class="col">
                    <div class="labelcont">{{item.contactNumber}} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">
                {{labelCaption['Reference Number (optional)']}}
                <span class="info-icon"
                      matTooltip="Please indicate the reference number that will be quoted in future correspondences with the liquidator or judicial manager."
                      matTooltipPosition="right"></span>
              </label>
              <input type="email" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.creditorReferenceNumber" [ngModelOptions]="{standalone: true}"
                     placeholder="{{jsonData['Reference_Number']}}" readonly>
            </div>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-md-12">
            <div class="form-group">
            <label class="form-label">{{labelCaption['Delivery Type']}}</label><br>
            <mat-checkbox [checked]="!hardcopy" [disabled]="!hardcopy || !accountmanager || lockScreen" (change)="check($event)" >
             I consent to the electronic delivery of notices or other documents to the registered email address.
            </mat-checkbox>
            </div>
          </div>
        </div>
        <div class="row marg-btm no-gutters">
          <div class="col-md-12">
            
            <button *ngIf="hardcopy && accountmanager && isSave;else else_part" class="secondary-button" (click)="showPopUp()">CANCEL</button>
            <ng-template #else_part>
            <button class="secondary-button" (click)="navigateToCreditorHome()">HOME</button></ng-template>
            <button *ngIf="hardcopy && accountmanager && isSave" class="primary-button float-right" (click)="updateCreditorDeliveryMode()">SAVE</button>
          </div>
        </div>
      </div>
      <div *ngIf="showIndividualForm && isCreditorSelected">
        <h2>{{labelCaption['Creditor_Information']}}</h2>

        <hr>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">{{labelCaption['First_Name']}}</label>
              <input formControlName="name" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.firstName" placeholder="First Name" readonly>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">{{labelCaption['Last_Name']}}</label>
              <input formControlName="lastName" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.lastName" placeholder="Last Name" readonly>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">{{labelCaption['NRIC/ FIN/ Passport No']}}</label>
              <input formControlName="nRICFINPassportNo" class="form-control is-disabled" placeholder="NRIC/ FIN/ Passport No."
                     [(ngModel)]="detailsOfUsers.nricfinPassportNo" readonly>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">
                {{labelCaption['Correspondence Mailing Address']}}
                <span class="info-icon"
                      matTooltip="Do inform the liquidators/judicial managers of any change in address.

                  This shall be the correspondence address for all paper correspondences.  Unless otherwise indicated, all correspondence will be done  electronically through email."
                      aria-label="Button that displays a tooltip when focused or hovered over"
                      matTooltipPosition="right"></span>
              </label>
              <input formControlName="correspondanceAddress" class="form-control is-disabled" placeholder="Postal Address Line 1" [(ngModel)]="detailsOfUsers.correspondenceMailingAddressLine1" readonly>

              <input type="email" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.correspondenceMailingAddressLine2" [ngModelOptions]="{standalone: true}" placeholder="Postal Address Line 2" readonly>
              <input type="email" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.correspondenceMailingAddressLine3" [ngModelOptions]="{standalone: true}" placeholder="Postal Address Line 3" readonly>
            </div>
          </div>
          <div class="col-md-6">

            <div class="form-group">
              <label class="form-label">{{labelCaption['Country']}}</label>

              <input formControlName="country2" type="text" placeholder="Select Country" class="form-control is-disabled"
                     [(ngModel)]="detailsOfUsers.correspondenceMailingCountry" readonly>
            </div>
            <div class="form-group">
              <label class="form-label">{{labelCaption['Postal Code']}}</label>
              <input formControlName="postalCode2" class="form-control is-disabled" placeholder="Postal Code"
                     [(ngModel)]="detailsOfUsers.correspondenceMailingPostalCode" readonly />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">{{labelCaption['Email_Address']}}</label>
              <input type="email" formControlName="email" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.emailAddress" placeholder="Email Address" readonly>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label">
                    {{labelCaption['Country_Code']}}
                  </label>
                  <input formControlName="countryCode" class="form-control is-disabled" placeholder="Country Code" readonly>
                </div>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <label class="form-label">{{labelCaption['Contact Number']}}</label>
                  <div class="add-contact-parent">
                    <input type="number" formControlName="contactNumber" class="form-control is-disabled"
                           placeholder="Contact Number" readonly>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="add-contact-section">
                  <div class="row no-gutters"  *ngFor="let item of detailsOfUsers.creditorContact"> 
                    <div class="col-2">
                      <div class="labelcont"> +{{item.countryCode}} </div>
                    </div>
                    <div class="col">
                      <div class="labelcont">{{item.contactNumber}} </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">
                {{labelCaption['Reference Number (optional)']}}
                <span class="info-icon"
                      matTooltip="Please indicate the reference number that will be quoted in future correspondences with the liquidator or judicial manager."
                      matTooltipPosition="right"></span>
              </label>
              <input type="email" class="form-control is-disabled" [(ngModel)]="detailsOfUsers.creditorReferenceNumber" [ngModelOptions]="{standalone: true}"
                     placeholder="{{jsonData['Reference_Number']}}" readonly>
            </div>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-md-12">
            <div class="form-group">
            <label class="form-label">{{labelCaption['Delivery Type']}}</label><br>
           <mat-checkbox [checked]="!hardcopy" [disabled]="!hardcopy || !accountmanager || lockScreen" (change)="check($event)">
           I consent to the electronic delivery of notices or other documents to the registered email address.
           </mat-checkbox>
          </div>
          </div>
        </div>
        <div class="row marg-btm no-gutters">
          <div class="col-md-12">
            
            <button *ngIf="hardcopy && accountmanager && isSave;else else_part" class="secondary-button" (click)="showPopUp()">CANCEL</button>
            <ng-template #else_part>
            <button class="secondary-button" (click)="navigateToCreditorHome()">HOME</button></ng-template>
            <button id="a" *ngIf="hardcopy && accountmanager && isSave" class="primary-button float-right" appDebounceClick (debounceClick)="updateCreditorDeliveryMode()" [debounceTime]="500">SAVE</button>
          </div>
        </div>
      </div>
      <button *ngIf="!isCreditorSelected"  class="secondary-button mb-4" (click)="navigateToCreditorHome()">HOME</button>
    </div>
    </div>
</form>

